module.exports = __webpack_public_path__ + "static/media/III TuNa Praia - 2 de abril de 2017.09fb94ab.jpg";